"use client"

import { useEffect } from "react"

/**
 * Remembers where a visitor arrived from, for the connector to read later.
 *
 * The connector's sign-in lives on mcp.garmin.daash.run and this site on
 * daash.run, and nothing else joins the two: a visit here is an anonymous
 * browser, a connection there is a signed-in person. A cookie set on the
 * parent domain is readable by both, so the connection can carry "came from
 * chatgpt.com" or "search" without carrying anything about the person. One
 * word, kept 30 days, set once per visitor; never overwritten by a later
 * visit, so the first way in is the one that counts.
 */
const COOKIE = "daash_src"
const OWN = new Set(["daash.run", "www.daash.run", "garmin.daash.run", "mcp.garmin.daash.run"])
const SEARCH = /(^|\.)(google|bing|duckduckgo|ecosia|yahoo|brave|startpage)\./

function clean(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9._-]/g, "").slice(0, 40)
}

export function SourceCookie() {
  useEffect(() => {
    try {
      if (document.cookie.split("; ").some((c) => c.startsWith(COOKIE + "="))) return
      const params = new URLSearchParams(window.location.search)
      let source = clean(params.get("utm_source") ?? params.get("ref") ?? "")
      if (!source && document.referrer) {
        const host = new URL(document.referrer).hostname.replace(/^www\./, "")
        if (!OWN.has(host)) source = SEARCH.test(host) ? "search" : clean(host)
      }
      source ||= "direct"
      const host = window.location.hostname
      const domain = host.endsWith("daash.run") ? "; Domain=.daash.run" : ""
      const secure = window.location.protocol === "https:" ? "; Secure" : ""
      document.cookie = `${COOKIE}=${source}; Path=/; Max-Age=${30 * 86400}; SameSite=Lax${domain}${secure}`
    } catch {
      /* no cookie, no harm */
    }
  }, [])
  return null
}
